import { Box } from "@mui/material"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/system"
import MeetingReviewCard from "components/meetings/MeetingReviewCard"
import ScheduleMeetingDialogCloseIconButton from "components/meetings/ScheduleMeetingDialog/ScheduleMeetingDialogCloseIconButton"
import ScheduleMeetingDialogContainer from "components/meetings/ScheduleMeetingDialog/ScheduleMeetingDialogContainer"
import ScheduleMeetingDialogContent from "components/meetings/ScheduleMeetingDialog/ScheduleMeetingDialogContent"
import ScheduleMeetingDialogHeader from "components/meetings/ScheduleMeetingDialog/ScheduleMeetingDialogHeader"
import ConventionAvailableMeetingTime from "models/convention-api/v1/ConventionAvailableMeetingTime"
import ConventionMeetingType from "models/convention-api/v1/ConventionMeetingType"
import React from "react"

interface ScheduleMeetingDialogReviewDateProps {
  selectedMeetingTime: ConventionAvailableMeetingTime
  selectedMeetingType: ConventionMeetingType
  isLoading: boolean

  onClose: () => void
  onCancel: () => void
}

const ScheduleMeetingDialogReviewDate = (props: ScheduleMeetingDialogReviewDateProps) => {
  const { onClose, selectedMeetingTime, selectedMeetingType, isLoading } = props

  return (
    <_Container>
      <ScheduleMeetingDialogHeader>
        <_AccentText>Your meeting is confirmed!</_AccentText>
        <ScheduleMeetingDialogCloseIconButton onClick={onClose} />
      </ScheduleMeetingDialogHeader>
      <ScheduleMeetingDialogContainer isLoading={isLoading}>
        <ScheduleMeetingDialogContent>
          <Typography component="p" sx={{ marginBottom: "24px", marginTop: "4px" }}>
            You’ll receive a confirmation shortly.
          </Typography>
          <MeetingReviewCard meetingTime={selectedMeetingTime} meetingType={selectedMeetingType} />
        </ScheduleMeetingDialogContent>
      </ScheduleMeetingDialogContainer>
    </_Container>
  )
}

export default ScheduleMeetingDialogReviewDate

const _AccentText = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,

  ...theme.fonts.lato400,
  fontSize: 20,
  lineHeight: 1.2,
}))

const _Container = styled(Box)({
  display: "flex",
  flexDirection: "column",

  minHeight: "360px",
  height: "100%",
})
